<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>ตั้งค่า</strong>
      </div>
      <div class="card-body">
        <div v-if="submit.active==false">
          <b-tabs>
            <b-tab active>
              <template slot="title">
                <strong>Url &nbsp; <i class="fas fa-link"></i></strong>
              </template>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Website URL&nbsp; : </label>
                    <input class="form-control" v-model="data.setting.site_url" type="text"
                      placeholder="กรุณากรอกWebsite URL">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Logo URL&nbsp; : </label>
                    <div class="row">
                      <div class="col-lg-8">
                        <input class="form-control" v-model="data.setting.logo_url" type="text"
                          placeholder="กรุณากรอกLogo URL">
                      </div>
                      <div class="col-lg-4">
                        <button type="button" class="btn btn-outline-primary btn-block w-full"
                          @click="openModal('logo_url')"><i class="far fa-upload"></i>
                          อัพโหลดรูปจากเครื่อง</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Facebook URL&nbsp; : </label>
                    <input class="form-control" v-model="data.setting.facebook_url" type="text"
                      placeholder="กรุณากรอกFacebook URL">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Line URL&nbsp; : </label>
                    <input class="form-control" v-model="data.setting.line_url" type="text"
                      placeholder="กรุณากรอกLine URL">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Whatsapp URL&nbsp; : </label>
                    <input class="form-control" v-model="data.setting.whatsapp_url" type="text"
                      placeholder="กรุณากรอกWhatsapp URL">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Script&nbsp; : </label>
                    <input class="form-control" v-model="data.setting.script" type="text" placeholder="กรุณากรอกScript">
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">
                <strong>Color &nbsp; <i class="fas fa-palette"></i></strong>
              </template>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">สีTheme Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.theme_color"></color-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">สีFont Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.font_color"></color-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">สีBackground Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.background_color"></color-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">สีBackground Cover Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.background_cover_color" has-alpha="true">
                    </color-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">สีปุ่ม Main Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.btn_main_color"></color-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">สีปุ่ม Info Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.btn_info_color"></color-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="name">สีปุ่ม Main Hover Color&nbsp; : </label>
                    <color-picker v-model="data.setting.theme_color.btn_main_hover_color"></color-picker>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">
                <strong>Navbar and Content &nbsp; <i class="fas fa-align-justify"></i></strong>
              </template>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Home Content 1&nbsp; : </label>
                    <input class="form-control" v-model="data.setting.home_content_1" type="text"
                      placeholder="กรุณากรอกHome Content 1">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Favicon&nbsp; : </label>


                    <div class="row">
                      <div class="col-lg-8">
                    <input class="form-control" v-model="data.setting.favicon" type="text"
                      placeholder="กรุณากรอกFavicon">
                      </div>
                      <div class="col-lg-4">
                        <button type="button" class="btn btn-outline-primary btn-block w-full"
                          @click="openModal('favicon')"><i class="far fa-upload"></i>
                          อัพโหลดรูปจากเครื่อง</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="data.setting.navbar">
                <div class="col-sm-12">
                  <div class="form-group">
                    <phone-option v-model="data.setting.navbar.phones"></phone-option>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Navbar Chat&nbsp; : </label>
                          <input class="form-control" v-model="data.setting.navbar.chat" type="text"
                            placeholder="กรุณากรอกNavbar Chat">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </b-tab>
            <b-tab>
              <template slot="title">
                <strong>Langauge &nbsp; <i class="fas fa-language"></i></strong>
              </template>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="form-check">
                      <input type="checkbox" id="enable" class="form-check-input"
                        v-model="data.setting.multi_lang.enable">
                      <label class="form-check-label">Multi language</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="data.setting.multi_lang.enable">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Main Lang&nbsp; : </label>
                          <input class="form-control" v-model="data.setting.multi_lang.main_lang" type="text"
                            placeholder="กรุณากรอกMain Lang">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Default Lang&nbsp; : </label>
                          <input class="form-control" v-model="data.setting.multi_lang.default_lang" type="text"
                            placeholder="กรุณากรอกDefault Lang">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">
                <strong>Welcome page &nbsp; <i class="fas fa-home"></i></strong>
              </template>
              <div class="col-lg-12 col-sm-12 form-group row" v-if="setting.languages.data.length != 1">
                <div v-for="language in setting.languages.data" :key="language.short_name" class="mx-1 text-center">
                  <b-button block variant="outline-info" @click="setLanguage(language.short_name)"
                    :class="{active: language.short_name === data.lang }">
                    {{ language.name }}
                    <span v-bind:class="'flag-icon flag-icon-us'"
                      v-if="covertoLowerCase(language.short_name)=='en'"></span>
                    <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)"
                      v-if="covertoLowerCase(language.short_name)!='en'"></span>
                  </b-button>
                </div>
              </div>
              <div class="row" v-if="data.setting.welcome[data.lang]">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">หัวเรื่อง Welcome<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.welcome[data.lang].title" type="text"
                            placeholder="กรุณากรอกหัวเรื่อง Welcome">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">รายละเอียด Welcome<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.welcome[data.lang].description" type="text"
                            placeholder="กรุณากรอกรายละเอียด Welcome">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Media Type<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.welcome[data.lang].media_type" type="text"
                            placeholder="กรุณากรอกMedia Type">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">VDO Script<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.welcome[data.lang].vdo_script" type="text"
                            placeholder="กรุณากรอกVDO Script">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Image Welcome<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <div class="row">
                            <div class="col-lg-8">
                              <input class="form-control" v-model="data.setting.welcome[data.lang].image" type="text"
                                placeholder="กรุณากรอกImage Welcome">
                            </div>
                            <div class="col-lg-4">
                              <button type="button" class="btn btn-outline-primary btn-block w-full"
                                @click="openModal('welcome')"><i class="far fa-upload"></i>
                                อัพโหลดรูปจากเครื่อง</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">
                <strong>Header &nbsp; <i class="fas fa-file"></i></strong>
              </template>
              <div class="col-lg-12 col-sm-12 form-group row" v-if="setting.languages.data.length != 1">
                <div v-for="language in setting.languages.data" :key="language.short_name" class="mx-1 text-center">
                  <b-button block variant="outline-info" @click="setLanguage(language.short_name)"
                    :class="{active: language.short_name === data.lang }">
                    {{ language.name }}
                    <span v-bind:class="'flag-icon flag-icon-us'"
                      v-if="covertoLowerCase(language.short_name)=='en'"></span>
                    <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)"
                      v-if="covertoLowerCase(language.short_name)!='en'"></span>
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">ชื่อเว็บ<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                      : </label>
                    <input class="form-control" v-model="data.setting.home_title[data.lang]" type="text"
                      placeholder="กรุณากรอกชื่อเว็บ">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">คำบรรยายเว็บไซต์<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                      : </label>
                    <input class="form-control" v-model="data.setting.home_description[data.lang]" type="text"
                      placeholder="กรุณากรอกคำบรรยายเว็บไซต์">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">หัวเรื่องของLogo<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                      : </label>
                    <input class="form-control" v-model="data.setting.logo_title[data.lang]" type="text"
                      placeholder="กรุณากรอกหัวเรื่องของLogo">
                  </div>
                </div>
              </div>
              <nav-option v-model="data.setting.nav_menu[data.lang]"></nav-option>
            </b-tab>
            <b-tab>
              <template slot="title">
                <strong>Content &nbsp; <i class="fas fa-edit"></i></strong>
              </template>
              <div class="col-lg-12 col-sm-12 form-group row" v-if="setting.languages.data.length != 1">
                <div v-for="language in setting.languages.data" :key="language.short_name" class="mx-1 text-center">
                  <b-button block variant="outline-info" @click="setLanguage(language.short_name)"
                    :class="{active: language.short_name === data.lang }">
                    {{ language.name }}
                    <span v-bind:class="'flag-icon flag-icon-us'"
                      v-if="covertoLowerCase(language.short_name)=='en'"></span>
                    <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)"
                      v-if="covertoLowerCase(language.short_name)!='en'"></span>
                  </b-button>
                </div>
              </div>
              <div class="row" v-if="data.setting.banner_default[data.lang]">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">รูปภาพ Banner<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <div class="row">
                            <div class="col-lg-8">
                              <input class="form-control" v-model="data.setting.banner_default[data.lang].image"
                                type="text" placeholder="กรุณากรอกURLรูปภาพ Banner">
                            </div>
                            <div class="col-lg-4">
                              <button type="button" class="btn btn-outline-primary btn-block w-full"
                                @click="openModal('banner_default')"><i class="far fa-upload"></i>
                                อัพโหลดรูปจากเครื่อง</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">ชื่อ Banner<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.banner_default[data.lang].title" type="text"
                            placeholder="กรุณากรอกชื่อ Banner">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">รายละเอียด Banner<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.banner_default[data.lang].description"
                            type="text" placeholder="กรุณากรอกรายละเอียด Banner">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Booking Link<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.banner_default[data.lang].booking_link"
                            type="text" placeholder="กรุณากรอกBooking Link">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">รายละเอียด Link<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.banner_default[data.lang].detail_link"
                            type="text" placeholder="กรุณากรอกรายละเอียด Link">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">ข้อมูล Booking<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.banner_default[data.lang].booking_text"
                            type="text" placeholder="กรุณากรอกข้อมูลBooking">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Detail Text<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.banner_default[data.lang].detail_text"
                            type="text" placeholder="กรุณากรอกข้อมูลDetail Text">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Contact<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <button class="btn btn-primary" @click="addNewContact" type="button"> เพิ่ม</button>

                        </div>
                      </div>
                      <div class="col-sm-4">
                        <draggable v-model="data.setting.contact[data.lang]" :options="{group:'people'}"
                          @start="drag=true" @end="drag=false" class="list-group">
                          <div class="list-group-item" v-for="(c, index) in data.setting.contact[data.lang]"
                            :key="c.title">
                            <h5 class="d-flex w-100 justify-content-between">
                              <span><i class="far fa-hospital"></i> {{c.name}}
                                {{c.branch ? `(${c.branch})` : ''}}</span>
                              <span @click="editContact(c, index)"><i class="far fa-edit"></i></span>
                              <span @click="removeContact(index)" style="margin-left: 10px;"><i
                                  class="far fa-trash"></i></span>
                            </h5>
                            <small>{{c.phone}}</small><br />
                            <small>{{c.working_hours}}</small>
                          </div>
                        </draggable>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="data.setting.seo_title_suffix[data.lang]">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">SEO Title Suffix<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                            : </label>
                          <input class="form-control" v-model="data.setting.seo_title_suffix[data.lang]" type="text"
                            placeholder="กรุณากรอกSEO Title Suffix">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>

          <br />

          <div class="form-group row">
            <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
              <button class="btn btn-primary w-full" type="submit" @click="submitSetting"><i
                  class="far fa-clipboard-check"></i>
                ยืนยัน</button>
            </div>
            <div class="col-sm-3 col-lg-3">
              <router-link :to="{ name: 'Dashboard'}"><button class="btn btn-secondary w-full" type="button"><i
                    class="far fa-times-square"></i>
                  ยกเลิก</button></router-link>
            </div>
          </div>
        </div>
        <div v-if="submit.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="'Contact'" ref="modal" v-model="setting.contact.active" @ok="saveContact">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Name<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.name" type="text"
                    placeholder="กรุณากรอกชื่อ">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Branch name<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.branch" type="text"
                    placeholder="กรุณากรอก Branch">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Address<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.address" type="text"
                    placeholder="กรุณากรอก Address">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Booking Logo<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.booking_logo" type="text"
                    placeholder="กรุณากรอก Booking Logo">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Booking URL<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.booking_url" type="text"
                    placeholder="กรุณากรอก Booking URL">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Lat<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.lat" type="text" placeholder="กรุณากรอกLat">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Lng<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.lng" type="text" placeholder="กรุณากรอกLng">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Map<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.map" type="text" placeholder="กรุณากรอกMap">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Phone<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.phone" type="text"
                    placeholder="กรุณากรอกเบอร์โทร">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Working Hours<span v-if="data.lang!=''"> {{data.lang}}</span>&nbsp;
                    : </label>
                  <input class="form-control" v-model="setting.contact.data.working_hours" type="text"
                    placeholder="กรุณากรอก Working Hours">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-bind:title="setting.modal.title" ref="model" hide-footer v-model="setting.modal.active"
      @ok="setting.modal.active = false">
      <div v-if="setting.img.upload.active==false">
        <div class="custom-file" v-if="setting.img.crop.active">
          <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
          <label class="custom-file-label" for="customFile">Choose file</label>
        </div>
        <div v-if="setting.img.view.active">
          <div v-if="setting.img.crop.active"
            style="width: 100%; height:68.5%; border: 1px solid gray; display: inline-block;">
            <vue-cropper ref='cropper' :src="setting.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
              :initialAspectRatio="100/68.5" :aspectRatio="100/68.5" :auto-crop-area="0.5" :min-container-width="100"
              :min-container-height="68.5" :background="true" :rotatable="true" alt="zeedoc-img-setting"
              :img-style="{ 'width': '100%', 'height': '68.5%' }">
            </vue-cropper>
          </div>
          <div>
            <div v-if="!setting.img.crop.active">
              <label for="ccnumber">ภาพที่จะแสดง <i class="far fa-image"></i></label>
              <img :src="setting.img.crop.src" style="width: 100%; height: 68.5%; border: 1px solid gray"
                alt="ตัวอย่างรูปที่จะนำเข้า" />
              <hr>
            </div>
          </div>
        </div>
        <div class="row" v-if="setting.img.crop.active && setting.img.view.src">
          <div class="offset-lg-2 col-lg-8">
            <br />
            <b-btn @click="cropImage" variant="primary" block>เลือกภาพนี้</b-btn>
          </div>
        </div>
        <div class="row" v-if="!setting.img.crop.active && setting.img.crop.src">
          <div class="col-lg-6">
            <b-btn variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
          </div>
          <div class="col-lg-6">
            <b-btn @click="cancleImage" variant="secondary" block>ยกเลิกภาพ</b-btn>
          </div>
        </div>
      </div>
      <div v-if="setting.img.upload.active">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <Loading :percent="load.percent" :active="load.active"></Loading>
  </div>
</template>
<script>
  import Loading from '../tool/Loading.vue';
  import colorPicker from '@/components/colorPicker'
  import navOption from '@/components/navOption'
  import phoneOption from '@/components/phoneOption'
  import draggable from 'vuedraggable'
  import VueCropper from 'vue-cropperjs'
  import Helper from '@/shared/helper'

  export default {
    components: {
      'Loading': Loading,
      'color-picker': colorPicker,
      draggable,
      navOption,
      phoneOption,
      VueCropper
    },
    mixins: [Helper],
    data() {
      return {
        test: [],
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        editedContact: {},
        editedContactIndex: 0,
        alert: {
          message: '',
          error: false
        },
        load: {
          task: 0,
          count: 0,
          percent: 0,
          active: false
        },
        authorization: 'Bearer ' + localStorage.getItem('z_token'),
        load: 0,
        submit: {
          active: false,
          error: false
        },
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        setting: {
          languages: {
            count: 1,
            data: []
          },
          contact: {
            index: 0,
            active: false,
            data: {
              address: "",
              booking_enable: true,
              booking_logo: "",
              booking_url: "",
              branch: "",
              lat: 13,
              lng: 100,
              map: "",
              name: "",
              phone: "",
              working_hours: ""
            }
          },
          img: {
            upload: {
              active: false
            },
            view: {
              src: '',
              active: false
            },
            crop: {
              src: '',
              active: false
            }
          },
          modal: {
            path: null,
            title: 'อัพโหลดรูปภาพ',
            action: '',
            active: false,
            upload: {
              active: false
            }
          }
        },
        data: {
          lang: 'th',
          image: '',
          setting: {
            "site_url": '',
            "home_title": {
              'th': ''
            },
            "home_description": {
              'th': ''
            },
            "theme_color": {
              "theme_color": '',
              "font_color": '',
              "background_color": '',
              "background_cover_color": '',
              "btn_main_color": '',
              "btn_main_hover_color": '',
              "btn_info_color": ''
            },
            "logo_url": '',
            "logo_title": {
              "th": ''
            },
            "nav_menu": {
              "th": [{
                  "title": "หน้าแรก",
                  "link": "/"
                },
                {
                  "title": "โปรโมชั่น",
                  "link": "/promotions"
                },
                {
                  "title": "ชำนาญเฉพาะทาง",
                  "sub_nav": []
                },
                {
                  "title": "บริการ",
                  "link": "/services"
                },
                {
                  "title": "แพทย์",
                  "link": "/doctors"
                },
                {
                  "title": "รีวิว",
                  "link": "/reviews"
                },
                {
                  "title": "บทความ",
                  "link": "/blog"
                }
              ]
            },
            "banner_default": {
              "th": {
                "image": '',
                "title": '',
                "description": '',
                "booking_link": '',
                "detail_link": '',
                "booking_text": '',
                "detail_text": ''
              }
            },
            "welcome": {
              "th": {
                "title": '',
                "description": '',
                "media_type": '',
                "vdo_script": '',
                "image": ''
              }
            },
            "contact": {
              "th": [{
                "name": '',
                "branch": '',
                "address": '',
                "phone": '',
                "working_hours": '',
                "lat": '',
                "lng": '',
                "booking_url": '',
                "booking_enable": '',
                "booking_logo": '',
                "map": ''
              }]
            },
            "facebook_url": '',
            "line_url": '',
            "home_content_1": '',
            "favicon": '',
            "seo_title_suffix": {
              "th": ''
            },
            "navbar": {
              "enable": true,
              "call": '',
              "chat": '',
              "phones": []
            },
            "multi_lang": {
              "enable": true,
              "main_lang": "th",
              "default_lang": "th"
            },
            "script": '',
            "whatsapp_url": '',
            "contact_option": {
              "enable": 1
            },
            "template_type": "clinic"
          }
        }
      }
    },
    methods: {
      cancleImage() {
        this.setting.modal.action = null
        this.setting.img.view.src = null
        this.setting.img.view.active = false
        this.setting.img.crop.active = true
        this.setting.img.crop.src = null
      },
      cancleImageLink() {
        this.setting.modal.action = null
        this.setting.img.view.active = false
        this.setting.img.crop.active = true
        this.setting.img.crop.src = null
        this.data.image = ''
      },
      saveContact() {
        this.data.setting.contact[this.data.lang][this.setting.contact.index] = this.setting.contact.data
        this.setting.contact.active = false
      },
      openModal(action) {
        this.setting.img.view.active = false
        this.setting.modal.action = action
        this.setting.img.crop.active = true
        this.setting.img.view.src = null
        this.setting.modal.title = 'อัพโหลดรูปจากเครื่อง'
        this.setting.modal.active = true
      },
      editContact(contact, index) {
        this.setting.contact.data = Object.assign({}, contact)
        this.setting.contact.index = index
        this.setting.contact.active = true
      },
      async submitImage() {
        if (this.setting.img.crop.src != '' && this.setting.img.crop.src) {
          this.setting.img.upload.active = true
          try {
            const cdnUrl = await this.uploadImageDataUrl(this.setting.img.crop.src, 'setting.jpg')
            this.setting.img.upload.active = false
            if (this.setting.modal.action === 'banner_default') {
              this.data.setting.banner_default[this.data.lang].image = cdnUrl;
            } else if (this.setting.modal.action === 'welcome') {
              this.data.setting.welcome[this.data.lang].image = cdnUrl;
            } else if (this.setting.modal.action === 'logo_url') {
              this.data.setting.logo_url = cdnUrl;
            }else if(this.setting.modal.action==='favicon'){
              this.data.setting.favicon = cdnUrl;
            }else {
              this.data.image = cdnUrl
            }
            this.cancleImageLink
            this.$refs.model.hide()
          } catch (error) {
            this.setting.img.upload.active = false
            alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!')
            this.cancleImageLink
            this.$refs.model.hide()
          }
        } else {
          this.setting.img.upload.active = false
          this.$refs.model.hide()
        }
      },
      setImage(e) {
        const file = e.target.files[0]
        this.setting.img.view.active = true
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.setting.img.view.src = event.target.result
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      cropImage() {
        this.setting.img.crop.active = false
        this.setting.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      removeContact(index) {
        this.data.setting.contact[this.data.lang].splice(index, 1)
      },
      addNewContact() {
        this.data.setting.contact[this.data.lang].unshift({
          "name": 'New clinic',
          "branch": '',
          "address": '',
          "phone": '',
          "working_hours": '',
          "lat": '',
          "lng": '',
          "booking_url": '',
          "booking_enable": '',
          "booking_logo": '',
          "map": ''
        })
      },
      updateThemeColor(value) {
        this.selected_theme_color = value.hex
      },
      okThemeColor() {
        this.data.setting.theme_color.theme_color = this.selected_theme_color
        this.display_theme_color_picker = false
      },
      cancelThemeColor() {
        this.display_theme_color_picker = false
      },
      covertoLowerCase(title) {
        if (title && title != '') {
          return title.toLowerCase()
        } else {
          return title
        }
      },
      async getOptions() {
        try {
          const request = await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/options', {
            headers: {
              Authorization: this.authorization
            }
          })
          this.data.setting = JSON.parse(request.bodyText).json
        } catch (e) {
          if (this.submit.error == false) {
            this.submit.error = true
            alert('การเชื่อมต่อมีปัญหา!')
          }
        }
      },
      async getSetting() {
        this.submit.active = true
        await this.getOptions()
        await this.getLanguages()
        this.submit.active = false
      },
      async getLanguages() {
        try {
          const request = await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/languages', {
            headers: {
              Authorization: this.authorization
            }
          })
          const data = JSON.parse(request.bodyText).json
          if (data) {
            this.setting.languages.count = data.length
            this.setting.languages.data = data
          }
          let value = null
          let shortName = null
          for (value of data) {
            shortName = value['short_name']
            if (!this.data.setting.home_title[shortName]) {
              this.data.setting.home_title[shortName] = ''
            }
            if (!this.data.setting.home_description[shortName]) {
              this.data.setting.home_description[shortName] = ''
            }
            if (!this.data.setting.logo_title[shortName]) {
              this.data.setting.logo_title[shortName] = ''
            }
            if (!this.data.setting.nav_menu[shortName]) {
              this.data.setting.nav_menu[shortName] = [{
                  "title": "Home",
                  "link": "/"
                },
                {
                  "title": "Promotions",
                  "link": "/promotions"
                },
                {
                  "title": "Specialists",
                  "sub_nav": []
                },
                {
                  "title": "Services",
                  "link": "/services"
                },
                {
                  "title": "Doctors",
                  "link": "/doctors"
                },
                {
                  "title": "Reviews",
                  "link": "/reviews"
                },
                {
                  "title": "Blog",
                  "link": "/blog"
                }
              ]
            }
            if (!this.data.setting.banner_default[shortName]) {
              this.data.setting.banner_default[shortName] = {
                "image": '',
                "title": '',
                "description": '',
                "booking_link": '',
                "detail_link": '',
                "booking_text": '',
                "detail_text": ''
              }
            }
            if (!this.data.setting.welcome[shortName]) {
              this.data.setting.welcome[shortName] = {
                "title": '',
                "description": '',
                "media_type": '',
                "vdo_script": '',
                "image": ''
              }
            }
            if (!this.data.setting.contact[shortName]) {
              this.data.setting.contact[shortName] = [{
                "name": '',
                "branch": '',
                "address": '',
                "phone": '',
                "working_hours": '',
                "lat": '',
                "lng": '',
                "booking_url": '',
                "booking_enable": '',
                "booking_logo": '',
                "map": ''
              }]
            }
            if (!this.data.setting.seo_title_suffix[shortName]) {
              this.data.setting.seo_title_suffix[shortName] = ''
            }
          }
        } catch (e) {
          if (this.submit.error == false) {
            this.submit.error = true
            alert('การเชื่อมต่อมีปัญหา!')
          }
        }
      },
      setLanguage(language) {
        this.data.lang = language
      },
      async submitSetting() {
        try {
          if (this.submit.error == false && this.submit.active == false) {
            this.submit.active = true
            await this.$http.put(process.env.VUE_APP_API_URL + 'api/v1/options', this.data.setting, {
              headers: {
                Authorization: this.authorization
              }
            })
            this.submit.active = false
            alert('บันทึกข้อมูลสำเร็จ')
          } else if (this.submit.error == true) {
            alert('การเชื่อมต่อมีปัญหา!')
          } else {
            alert('กรุณารอโหลดข้อมูลสักครู่!')
          }
        } catch (e) {
          alert('การบันทึกข้อมูลมีปัญหา กรุณาตรวจสอบเครื่อข่าย!')
        }
      }
    },
    mounted() {
      this.getSetting()
    }
  }

</script>
<style lang="scss">
  .color-picker {
    position: absolute;
    z-index: 1;
    top: 70px;
    left: 30px;
  }

</style>
